<template>
    <div
        class="Issue"
        :class="[level]"
    >
        <WText>
            <WText
                :size="14"
                tag="span"
                weight="semi"
                uppercase
                class="Status"
                :class="[level]"
            >
                {{ $tc(`imports.create.notifications.${level}`) }}
            </WText>
            <WText
                :size="14"
                tag="span"
            >
                - {{ message }}
            </WText>
        </WText>
    </div>
</template>

<script>
import VueTypes from 'vue-types'

export default {
    name: 'Issue',
    props: {
        title: VueTypes.string,
        message: VueTypes.string,
        level: VueTypes.oneOf(['success', 'error', 'warning', 'info', '']),
    },
}
</script>
<style scoped lang="scss">
.Issue {
    padding: 15px;
    border-radius: $border-radius;

    &.success {
       background: rgba($success, .1);
    }

    &.error {
       background: rgba($danger, .1);
    }

    &.warning {
       background: rgba($warning, .1);
    }

    &.info {
        background: rgba($info, .1);
    }
}

.WText.Status {
    &.success {
        color: $success;
    }
    &.error {
        color: $danger;
    }
    &.warning {
        color: $warning;
    }
    &.info {
        color: $info;
    }
}
</style>
